<template>



    <form class="sm:flex sm:max-w-md" @submit.prevent="subscribeToNewsletter">
        <input v-model="email" id="email" name="email" type="email" autocomplete="email" placeholder="Enter your email"
            class="w-full min-w-0 rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-electric-600 sm:w-56 sm:text-sm/6" />

        <div class="mt-4 sm:mt-0 sm:ml-4 sm:shrink-0">
            <button type="submit" :disabled="loading"
                class="flex items-center justify-center w-full px-3 py-2 text-sm font-semibold rounded-md shadow-xs bg-clay-950 text-clay-100 hover:bg-clay-900 hover:text-clay-50 hover:shadow-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-electric-600">
                {{ loading ? "Subscribing..." : "Subscribe" }}
            </button>
        </div>
    </form>
    <p v-if="successMessage" class="block text-sm font-medium text-green-700">{{ successMessage }}</p>
    <p v-if="errorMessage" class="block text-sm font-medium text-red-900">{{ errorMessage }}</p>

</template>

<script setup>
import { ref } from "vue";

const email = ref("");
const loading = ref(false);
const successMessage = ref("");
const errorMessage = ref("");

const subscribeToNewsletter = () => {
    if (!email.value) return;
    loading.value = true;
    successMessage.value = "";
    errorMessage.value = "";

    try {
        analytics.identify({
            id: email.value,
            email: email.value,
            source: "newsletter_signup_box",
            cio_subscription_preferences: {
                topics: {
                    topic_1: true, //StageAgent Newsletter
                    topic_2: false,
                    topic_4: false,
                    topic_6: true, //Product Updates
                    topic_7: false,
                    topic_8: true, //StageAgent Offers
                    topic_9: true, //3rd Party Promotions
                    topic_10: false,
                }
            }
        });

        successMessage.value = "Thank you for subscribing!";
        email.value = "";
    } catch (error) {
        errorMessage.value = "Something went wrong. Please try again.";
    } finally {
        loading.value = false;
    }
};
</script>

<style scoped>

</style>
